import React from 'react';

import {
  fetchInstructorProfile,
  fetchContentListByInstructor,
} from 'reduxModules/instructorProfile/action';
import {
  fetchInstructorProfileFlow,
  fetchContentListByInstructorFlow,
} from 'reduxModules/instructorProfile/saga';
import { getInstructor } from 'reduxModules/instructorProfile/selector';
import Layout from 'components/Layout';
import ContentListByInstructor from './ContentListByInstructor';

async function action(context) {
  const {
    i18n,
    store,
    params: { id, type },
  } = context;

  await Promise.all([
    store
      .runSagas(fetchInstructorProfileFlow, fetchInstructorProfile({ id }))
      .toPromise(),
    store
      .runSagas(
        fetchContentListByInstructorFlow,
        fetchContentListByInstructor({ id, contentType: type }),
      )
      .toPromise(),
  ]);

  const { name: instructor } = getInstructor(store.getState());

  const key = type.replace(/-[a-z]/, letter => {
    return letter[1].toUpperCase();
  });

  return {
    title: i18n.t(`seo:seo.instructorProfile.${key}.title`, {
      instructor,
    }),
    description: i18n.t(`seo:seo.instructorProfile.${key}.description`),
    chunks: ['ContentListByInstructor'],
    component: (
      <Layout>
        <ContentListByInstructor id={id} contentType={type} />
      </Layout>
    ),
  };
}

export default action;
